import {Component, OnInit} from '@angular/core';
import {NewPageService} from '../../templates/new-page/service/new-page.service';
import {NewPageList} from '../../core/models/new-page-list';

import {ConfirmationService} from 'primeng/components/common/confirmationservice';
import {Constants} from '../../core/config/Constants';

@Component({
  selector: 'app-coordinator-select',
  templateUrl: './coordinator-select.component.html',
  styleUrls: ['./coordinator-select.component.css'],
  providers: [NewPageService]
})
export class CoordinatorSelectComponent implements OnInit {
  constructor(private newPageService: NewPageService, private confirmationService: ConfirmationService) {
    this.newPageService.validate$.subscribe(validate => {
      if (validate) {
        this.validate();
      }
    });
  }

  aboutUs: NewPageList;
  showListOptions: boolean = false;
  selectorTitle = '';
  
  aboutUsType: string;
  speakerList: any[];
  checkBoxSpeaker: any[] = [];
  hasText = '';
  textSizes = [14, 16, 18, 20, 22, 24, 26, 28, 30, 32];
  textStyles = [
    Constants.ABOUT_TYPE_TEXT_PREF_STYLE_NORMAL,
    Constants.ABOUT_TYPE_TEXT_PREF_STYLE_BOLD,
    Constants.ABOUT_TYPE_TEXT_PREF_STYLE_ITALIC,
    Constants.ABOUT_TYPE_TEXT_PREF_STYLE_BOLDITALIC
  ];

  textClass = '';

  ngOnInit() {
    if (
      this.aboutUs.aboutPrefs &&
      (this.aboutUs.aboutPrefs.textsize === undefined || this.aboutUs.aboutPrefs.textstyle === undefined)
    ) {
      this.aboutUs.aboutPrefs.textsize = 14;
      this.aboutUs.aboutPrefs.textstyle = 'normal';
    }

    if(this.aboutUsType == 'coordinator'){
      this.showListOptions = this.aboutUs.hasSpecificSpeakers;
    }
    if(this.aboutUsType == 'topics'){
      this.showListOptions = this.aboutUs.hasSpecificTopics;
    }
    // console.log('SpeakerSelect', this.aboutUsType, this.speakerList.map(x=>x.title))
  }

  eventText: boolean = true;

  _ref: any;

  addRemoveCoordinator(speakerIndex: number, speakerDetails) {
    console.log({ speakerIndex, speakerDetails })
    if (this.aboutUsType == 'coordinator') {
      this.aboutUs.specificSpeakersList = this.speakerList.filter((sp, index) => {
        if (this.checkBoxSpeaker[index]) return true;
        else false;
      }).map(sp => sp.$key)
    }
    if (this.aboutUsType == 'topics') {
      this.aboutUs.specificTopicsList = this.speakerList.filter((sp, index) => {
        if (this.checkBoxSpeaker[index]) return true;
        else false;
      }).map(sp => sp.$key)
    }
  }

  toggleHasOptions(){
    if(this.aboutUsType == 'coordinator'){
      this.aboutUs.hasSpecificSpeakers = this.showListOptions
      if(!this.showListOptions){
        this.aboutUs.specificSpeakersList = []
      }
    }
    else if(this.aboutUsType == 'topics'){
      this.aboutUs.hasSpecificTopics = this.showListOptions
      if(!this.showListOptions){
        this.aboutUs.specificTopicsList = []
      }
    }
  }

  confirmDelete() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete ?',
      accept: () => {
        this.remove();
      }
    });
  }

  remove() {
    this.newPageService.removeItem(this.aboutUs);
    console.log('remove');
    this._ref.destroy();
  }

  upItem() {
    this.newPageService.upItem(this.aboutUs);
  }

  downItem() {
    this.newPageService.downItem(this.aboutUs);
  }

  validate() {
    if (this.aboutUs.text == null || this.aboutUs.text.trim().length < 1) {
      this.textClass = 'fieldWithErrors';
    } else {
      this.textClass = '';
    }
  }

  textSizeOnChange(size) {
    this.aboutUs.aboutPrefs.textsize = parseInt(size);
  }

}



// WEBPACK FOOTER //
// /app/src/app/layout/coordinator-select/coordinator-select.component.ts